import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
} from '@angular/core';
import { HookDirective } from '../core/hook';
import { useSubscriptionLatest } from '../core/hooks';
import { DirtyService } from './dirty.service';

@Component({
  selector: 'dirty',
  templateUrl: './dirty.component.html',
  styleUrls: ['./dirty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirtyComponent extends HookDirective {
  constructor(
    readonly dirtyService: DirtyService,
    _cdr: ChangeDetectorRef,
  ) {
    super(_cdr);
  }

  get _() {
    const isDirtyState = useSubscriptionLatest(this.dirtyService.isDirty, []);

    return {
      isDirtyState,
    };
  }

  warn = 'You have unsaved changes!  Discard?';

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    if (this._.isDirtyState) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.returnValue = true;
      //NOTE: most modern browsers block or ignore calls to confirm, alert, or prompt within beforeunload event handlers
      //So the below confirm is never run on beforeunload and instead throws
      //‘Blocked confirm('You have unsaved changes! Discard?') during beforeunload.’
      confirm(this.warn);
      return this.warn;
    }
  }
}
